export default function () {
  const widgetName = 'footerimagebackground';
  const widgetOpts = footerimagebackgroundOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function () {
      const imageContainer = $(`#${widgetName} .image-container img`);
      const imageUrl = imageContainer.data('src') || imageContainer.attr('src');
      $('.footer').css({
        'background-image': `url(${imageUrl})`,
      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: 'Learn More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
} // arguments: data, owl, hasData
